import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Button, TextField, Paper} from '@material-ui/core';
import {makeHighlightStyle} from 'theme';
import stringFromNode from 'helpers/stringFromNode';
import {useTextResponse} from 'data/queries/responses';

const useStyles = makeStyles(theme => {
  const highlightStyle = makeHighlightStyle(theme);
  return {
    card: highlightStyle({
      colors: theme.palette.legacy.actionHighlight.action,
      before: {content: `'\\e312'`}, // keyboard e312
    }),
    textbox: {
      backgroundColor: theme.palette.background.default,
    },
  };
});

const TextResponse = ({prompt, answer, selfcheck}) => {
  const promptText = stringFromNode(prompt);
  const [_latestResponse, createResponse] = useTextResponse(promptText);
  const [submitted, setSubmitted] = React.useState(false);

  const [value, setValue] = React.useState('');
  const onChange = event => setValue(event.target.value);
  const submit = e => {
    e.preventDefault();
    setSubmitted(true);
    createResponse(value);
  };
  const classes = useStyles();

  // if there's a selfcheck child element, we want the same thing
  // but with an added 'promptText' prop
  const selfcheckWithPromptText = selfcheck && React.cloneElement(selfcheck, {promptText});

  return (
    <Box marginBottom={4} className={classes.card}>
      <Box fontSize={20} mt={1} mb={2} className={classes.prompt}>
        {prompt}
      </Box>
      <form onSubmit={submit}>
        <Box fontSize={20} mt={1} mb={2}>
          <Box mb={1} className={classes.textbox}>
            <TextField
              InputProps={{
                inputProps: {'aria-label': prompt},
              }}
              value={value}
              onChange={onChange}
              disabled={submitted}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
            />
          </Box>
          <Box>
            {submitted ? (
              (answer || selfcheck) && (
                <Paper>
                  <Box p={2}>
                    {answer}
                    {selfcheckWithPromptText}
                  </Box>
                </Paper>
              )
            ) : (
              <>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={submitted}
                  onClick={submit}
                >
                  Submit
                </Button>
              </>
            )}
          </Box>
        </Box>
      </form>
    </Box>
  );
};

TextResponse.propTypes = {
  prompt: PropTypes.node.isRequired,
  answer: PropTypes.node,
};

export default TextResponse;
